import BaseApi from "@api/base.api";

export default class ClientsApi extends BaseApi {
    static get entity() {
        return "clients";
    }

    static getClientForSelect() {
        return this.get(`${this.entity}/select`);
    }
}
